/**
 * Dashboard Type Selector - Switch between Patient Counts vs Medical Director
 * Issue #77: Dashboard migration - missing dropdown feature
 */

import { Select } from 'antd';
import { useAppSelector, useAppDispatch } from '../../../store/hooks';
import { setDashboardType } from '../../../store/dashboardSlice';
import type { DashboardType } from '../types/dashboard.types';

const { Option } = Select;

interface DashboardAuthContext {
  employee?: {
    permissions?: string[];
  };
  permissions?: string[];
  user?: {
    is_superuser?: boolean;
  };
}

function DashboardTypeSelector() {
  const dispatch = useAppDispatch();
  const { dashboardType } = useAppSelector(state => state.dashboard.filters);
  const authContext = (window as Window & { authContext?: DashboardAuthContext }).authContext;
  const permissions: string[] = authContext?.employee?.permissions || authContext?.permissions || [];
  const isSuperuser = Boolean(authContext?.user?.is_superuser);
  const canViewStandardDashboards = isSuperuser || permissions.includes('dashboard');
  const canViewQualityDashboard = isSuperuser || permissions.includes('quality_dashboard');

  const handleChange = (value: DashboardType) => {
    dispatch(setDashboardType(value));
    // Navigate to the selected dashboard type (matches AngularJS implementation)
    window.location.href = `/dashboard/#/${value}`;
  };

  return (
    <div className="filter" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <label htmlFor="dashboard-select">Dashboard:</label>
      <Select
        id="dashboard-select"
        value={dashboardType}
        onChange={handleChange}
        style={{ width: '180px' }}
      >
        {canViewStandardDashboards && (
          <>
            <Option value="info">Patient Counts</Option>
            <Option value="med_dash">Medical Director</Option>
          </>
        )}
        {canViewQualityDashboard && (
          <Option value="quality">Quality Executive</Option>
        )}
      </Select>
    </div>
  );
}

export default DashboardTypeSelector;
